export default "__VITE_ASSET__d7a0b183__"